import { ReactNode, SyntheticEvent } from 'react'
import styled from 'styled-components'
import RouterLink from 'shared/components/router/link'
import { useHistory } from 'react-router'

const Inactive = styled.span`
    opacity: 0.5;
    pointer-events: none;
`

type Props = {
    gif: any
    children?: ReactNode
    className?: string
}

const NextPrev = ({ gif, children, className }: Props) => {
    const history = useHistory()

    return gif ? (
        <RouterLink
            className={`${className}`}
            onClick={(e: SyntheticEvent<HTMLElement, Event>) => {
                e.preventDefault()
                history.push(gif.path)
            }}
            href={gif.path}
        >
            {children}
        </RouterLink>
    ) : (
        <Inactive className={`${className}`}>{children}</Inactive>
    )
}

export default NextPrev
